import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { useRegistration } from '@/hooks/useRegistration';
import { isRegulatedLocale } from '@/shared/utility';
import { WrapperPlatform } from '@/models/enum/wrapper-platform.enum';
import { setWrapperPlatform } from '@/store/actions/commonActions';
import { OpenedFrom } from '@/lib/gTagManager';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

const useSearchParams = (): void => {
  const { search } = useLocation();
  const [modal, setModal] = useState<string | null>(null);
  const [platform, setPlatform] = useState<string | null>(null);
  const dispatch = useDispatch();
  const { openModal } = useModal();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const locale = useSelector(selectLocale);
  const { openRegistration } = useRegistration();

  useEffect(() => {
    const params = new URLSearchParams(search);
    setModal(params.get('modal'));
    setPlatform(params.get('platform'));
  }, [search]);

  useEffect(() => {
    if (platform === 'ios') {
      dispatch(setWrapperPlatform(WrapperPlatform.iOS));
    } else if (platform === 'android') {
      dispatch(setWrapperPlatform(WrapperPlatform.Android));
    }
  }, [platform]);

  useEffect(() => {
    if (isAuthenticated) {
      return;
    }

    if (modal === 'login') {
      openModal(MODALS.LOGIN);
    }

    if (locale && modal === 'register') {
      openRegistration({ openedFrom: OpenedFrom.UrlParams });
    }

    if (locale && modal === 'logged-out') {
      if (isRegulatedLocale(locale)) {
        openModal(MODALS.PAYNPLAY_IFRAME, { loggedOut: true });
      } else {
        openModal(MODALS.LOGIN, { loggedOut: true });
      }
    }
  }, [locale, modal]);
};

export default useSearchParams;
